(function($) {
  'use strict';

  const hero = {
    dom: function() {
      this.$hero = $('#hero');
      this.$video = $('#homeVideo');
      this.$parallaxImages = $('[data-parallax-image]');
      this.$heroRotator = $('#heroRotator');
      this.$heroSlide = $('.homepage__rotator-slide');
    },

    video: function() {
      var self = this;
      var debug = window.location.search.match(/debug-video=1/);
      var videoLoopLimit = jcms.video_loop_limit;

      if (this.$video.length) {
        var loop = 0;
        var video = this.$video.get(0);

        $('.flex-direction-nav').hide();

        if (debug) {
          $('.homepage__rotator-dimmer').hide();
          $('.homepage__rotator-content').hide();
          this.$video.attr('controls', true);
        }

        if (videoLoopLimit != '' && videoLoopLimit != null) {
          this.$video.removeAttr('loop');

          if (videoLoopLimit == 'auto') {
            video.onloadedmetadata = function() {
              var duration = Math.floor(this.duration);
              videoLoopLimit = duration > 180 ? 1 : Math.floor(180 / duration);

              if (debug) {
                console.log('Video loop limit (auto): ' + videoLoopLimit);
              }
            };
          }
          else {
            videoLoopLimit = parseInt(videoLoopLimit);

            if (debug) {
              console.log('Video loop limit (explicit): ' + videoLoopLimit);
            }
          }

          video.addEventListener('ended', function() {
            if (loop < videoLoopLimit) {
              if (debug) {
                console.log('video looped');
              }

              this.currentTime = 0;
              this.play();
              ++loop;
            }
            else {
              // self.$video.hide();

              if (self.$video.data('fallback-to-rotator') == 1) {
                $('.homepage__rotator-slides').show();
                $('.flex-direction-nav').show();
                $('#homepage-video-overlay').hide();
                self.$video.hide();

                if (self.$rotator.length) {
                  self.$rotator.trigger('set-image-height');
                }
              }
              else {
                // $('.homepage__video-fallback').show();
                video.src = '';
              }

              if (debug) {
                console.log('video loop limit reached');
              }
            }
          });
        }
        else if (debug) {
          console.log('Video loop limit: none');
        }
      }
    },

    heroRotator: function() {
      if (typeof jcms.rotator_settings !== 'undefined') {
        this.$hero.flexslider({
          controlNav: jcms.rotator_settings.nav === 'control' ? true : false,
          directionNav: jcms.rotator_settings.nav === 'direction' ? true : false,
          slideshowSpeed: jcms.rotator_settings.speed,
          namespace: '',
          selector: '.homepage__rotator-slide',
          customDirectionNav: $(".homepage__rotator-nav button"),
          start: function(rotator) {
            hero.$hero.addClass('loaded');
            hero.$heroSlide.height('');
            if ($(window).width() < jcms.breakpoints.fluid_medium) {
              hero.$heroSlide.height(hero.$heroRotator.height());
            }
            if (rotator.slides && rotator.slides[rotator.currentSlide]) {
              hero.loadRotatorImage(rotator.slides[rotator.currentSlide]);

              $(rotator.slides[rotator.currentSlide]).addClass('run-animation');
            }
          },
          before: function(rotator) {
            var current = rotator.currentSlide;
            var next = rotator.animatingTo;

            // -- Aids in Ken Burns transitions.
            setTimeout(function() {
              $(rotator.slides[current]).removeClass('run-animation');
            }, 500);

            $(rotator.slides[next]).addClass('run-animation');

            hero.loadRotatorImage(rotator.slides[next]);
          }
        });

        $(window).on('resize', function() {
          hero.$heroSlide.height('');
          if ($(window).width() < jcms.breakpoints.fluid_medium) {
            hero.$heroSlide.height(hero.$heroRotator.height());
          }
        });
      }
    },

    loadRotatorImage: function(slide) {
      let $slide = $(slide);
      let $image = $slide.find('[data-manual-src], [data-manual-srcset]');

      if ($image.length) {
        $image.each(function() {
          if (!$(this).data('loaded')) {
            if ($(this).attr('data-manual-src')) {
              $(this).attr('src', $(this).data('manual-src')).data('loaded', 1);
            }
            else {
              $(this).attr('srcset', $(this).data('manual-srcset')).data('loaded', 1);
            }
          }
        });
      }
    },

    rotatorTopOffset: {
      doOffset: function() {
        if (hero.$hero.hasClass('rotator-parallax--fixed')) {
          const doOffset = true;
          const topOffset = hero.$hero.offset().top - $(window).scrollTop();
          const $images = hero.$hero.find('.homepage__rotator-image');

          if (doOffset) {
            if (topOffset >= 0) {
              hero.$hero.removeClass('parallaxed');
              $images.css({position: ''});
            }
            else {
              hero.$hero.addClass('parallaxed');
              $images.css({position: 'fixed'});
            }
          }
          else {
            hero.$hero.removeClass('parallaxed');
            $images.css({left: 0, width: '100%'});
          }
        }
      },

      init: function() {
        var self = this;

        $(window).on('load scroll resize', function() {
          self.doOffset();

          hero.$hero.trigger('set-image-height');
        });

        setTimeout(function() {
          hero.$hero.find('.homepage__rotator-image').css('opacity', 1);
        }, 200);
      }

    },

    parallax: function() {
      if (this.$parallaxImages.length) {
        this.$parallaxImages.each(function() {
          var $this = $(this);
          var scale = 1.3;
          var scaleSize = $(this).data('parallax-image');

          switch (scaleSize) {
            case 'default':
              // -- Default is 1.3
              break;
            case 'large':
              scale = 1.5;
              break;
            case 'largest':
              scale = 1.7;
              break;
          }

          setTimeout(function() {
            $this.css('opacity', 1);

            new simpleParallax($this.get(0), {
              delay: .3,
              scale: scale
            });
          }, 200);
        });
      }
    },

    ready: function() {
      this.dom();
      this.video();
      this.heroRotator();
      this.rotatorTopOffset.init();
      this.parallax();
    }
  };

  $(function() { hero.ready(); });

})(jQuery);
